import { useRouter } from '@application/utils';
import {
  Button,
  CardItemContainer,
  Container,
  EmptyOverlay,
  InfoBox,
  MtCardItemAnimal,
  MtLayouTitleEditButton,
  MtLayouTitleEditButtonContainer,
  MtLayoutTitleWrapper,
  Section,
  SectionTitle,
} from '@presentation/components';
import { Illustration } from '@presentation/components/Illustration';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import { FaExternalLinkAlt, FaPlus } from 'react-icons/fa';
import { TbArrowNarrowLeft, TbArrowNarrowRight } from 'react-icons/tb';
import { PageSkeleton } from './components/PageSkeleton';
import * as Styled from './styled';
import type { MtAnimalsBreederPageData } from './types';

export * from './types';

export const MtAnimalsBreederPage: FC<MtAnimalsBreederPageData> = (props) => {
  const { items, loading = false, showArchived, onAddClick, onToggleShowArchived } = props;
  const { translate } = useTranslation();
  const { navigateToRoute } = useRouter();

  return (
    <Container>
      <MtLayoutTitleWrapper>
        <SectionTitle>{translate('mt.breeder.animals.animalsTitle')}</SectionTitle>

        <MtLayouTitleEditButtonContainer>
          <MtLayouTitleEditButton onClick={() => navigateToRoute('studList')}>
            <span>{translate('common.buttons.explore')}</span>
            <FaExternalLinkAlt />
          </MtLayouTitleEditButton>

          <MtLayouTitleEditButton onClick={() => onToggleShowArchived(!showArchived)} color="dark">
            {showArchived ? (
              <>
                <TbArrowNarrowLeft />
                <span>{translate('common.buttons.back')}</span>
              </>
            ) : (
              <>
                <span>{translate('glossary.archives')}</span>
                <TbArrowNarrowRight />
              </>
            )}
          </MtLayouTitleEditButton>
        </MtLayouTitleEditButtonContainer>
      </MtLayoutTitleWrapper>

      <InfoBox>
        <BsFillCheckCircleFill /> <span>{translate('mt.breeder.animals.info')}</span>
      </InfoBox>

      {loading && <PageSkeleton />}
      {!loading && !items.length && (
        <Section>
          <EmptyOverlay icon={<Illustration type="parent" />}>
            {!showArchived && (
              <Button size="medium" color="blue" iconRight={<FaPlus />} shrink onClick={onAddClick}>
                {translate('common.buttons.addAnimal')}
              </Button>
            )}
          </EmptyOverlay>
        </Section>
      )}
      {!loading && !!items.length && (
        <>
          <CardItemContainer>
            {items.map((item, index) => (
              <Styled.CardItemWrapper key={index}>
                <MtCardItemAnimal {...item} />
              </Styled.CardItemWrapper>
            ))}
          </CardItemContainer>
          {!showArchived && (
            <Section centerChildren>
              <Button size="medium" color="blue" shrink iconRight={<FaPlus />} onClick={onAddClick}>
                {translate('common.buttons.addAnimal')}
              </Button>
            </Section>
          )}
        </>
      )}
    </Container>
  );
};
